import React, { Component } from "react";
import styled from "styled-components";
import axios from "axios";
import moment from "moment";

import {
  baseUrl,
  parentChildrenUrl,
  signins,
} from "@/database/homePage/services.json";

const Div = styled.div`
  position: relative;
  width: 52rem;
  height: 64rem;
  background-color: #ffffff;
  border-radius: 2.4rem;

  .form-shadow1 {
    position: absolute;
    top: 2.4rem;
    left: -2.5rem;
    width: 57rem;
    height: 59.2rem;
    background-color: rgba(255, 255, 255, 0.24);
    border-radius: 2.4rem;
    z-index: 2;
  }

  .form-shadow2 {
    position: absolute;
    top: 4.8rem;
    left: -5rem;
    width: 62rem;
    height: 54.4rem;
    background-color: rgba(255, 255, 255, 0.14);
    border-radius: 2.4rem;
    z-index: 1;
  }

  .form-main {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    z-index: 3;

    .form-title {
      font-size: 2.4rem;
      color: #333333;
    }

    .form-content {
      width: 45rem;
      height: 38.2rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      .form-item {
        width: 100%;
        display: flex;
        align-items: center;
        height: 4.2rem;

        .form-name {
          position: relative;
          width: 20%;
          font-size: 1.6rem;
          color: #333333;

          &.level0::before {
            position: absolute;
            content: "";
            width: 0.6rem;
            height: 0.6rem;
            border-radius: 50%;
            background-color: #e63737;
            top: 0.9rem;
            left: -1rem;
          }

          &.level1::before {
            position: absolute;
            content: "";
            width: 0.6rem;
            height: 0.6rem;
            border-radius: 50%;
            background-color: #e63737;
            top: 0.9rem;
            left: -1rem;
          }

          &.student-name::before {
            position: absolute;
            content: "";
            width: 0.6rem;
            height: 0.6rem;
            border-radius: 50%;
            background-color: #e63737;
            top: 0.9rem;
            left: -1rem;
          }
        }

        .form-radio {
          position: relative;
          width: 80%;
          height: 100%;
          background-color: #f4f4f4;
          border: 1px solid #dddddd;
          border-radius: 0.4rem;
          cursor: pointer;
          line-height: 4.2rem;
          padding-left: 1rem;
          color: black;
          font-size: 1.6rem;

          .radio-items-container {
            position: absolute;
            top: 4.2rem;
            left: 0;
            width: 100%;
            background-color: #f4f4f4;
            border: 1px solid #dddddd;
            border-radius: 0.4rem;
            z-index: 99;
            max-height: 45rem;
            overflow-y: scroll;

            .radio-item {
              padding-left: 1rem;

              &:hover {
                background-color: #1677ff;
                color: white;
              }
            }
          }

          &.level0::before {
            position: absolute;
            right: 1rem;
            top: ${(props) =>
              props.selectedLevel === "0" ? "1.35rem" : "1.8rem"};
            content: "";
            width: 0.9rem;
            height: 0.9rem;
            border-top: ${(props) =>
              props.selectedLevel === "0"
                ? `0.45rem solid transparent`
                : `0.45rem solid #bbbbbb;`};
            border-bottom: ${(props) =>
              props.selectedLevel === "0"
                ? `0.45rem solid #bbbbbb`
                : `0.45rem solid #transparent;`};
            border-left: 0.45rem solid transparent;
            border-right: 0.45rem solid transparent;
          }

          &.level1::before {
            position: absolute;
            right: 1rem;
            top: ${(props) =>
              props.selectedLevel === "1" ? "1.35rem" : "1.8rem"};
            content: "";
            width: 0.9rem;
            height: 0.9rem;
            border-top: ${(props) =>
              props.selectedLevel === "1"
                ? `0.45rem solid transparent`
                : `0.45rem solid #bbbbbb;`};
            border-bottom: ${(props) =>
              props.selectedLevel === "1"
                ? `0.45rem solid #bbbbbb`
                : `0.45rem solid #transparent;`};
            border-left: 0.45rem solid transparent;
            border-right: 0.45rem solid transparent;
          }

          &.level2::before {
            position: absolute;
            right: 1rem;
            top: ${(props) =>
              props.selectedLevel === "2" ? "1.35rem" : "1.8rem"};
            content: "";
            width: 0.9rem;
            height: 0.9rem;
            border-top: ${(props) =>
              props.selectedLevel === "2"
                ? `0.45rem solid transparent`
                : `0.45rem solid #bbbbbb;`};
            border-bottom: ${(props) =>
              props.selectedLevel === "2"
                ? `0.45rem solid #bbbbbb`
                : `0.45rem solid #transparent;`};
            border-left: 0.45rem solid transparent;
            border-right: 0.45rem solid transparent;
          }

          &.level3::before {
            position: absolute;
            right: 1rem;
            top: ${(props) =>
              props.selectedLevel === "3" ? "1.35rem" : "1.8rem"};
            content: "";
            width: 0.9rem;
            height: 0.9rem;
            border-top: ${(props) =>
              props.selectedLevel === "3"
                ? `0.45rem solid transparent`
                : `0.45rem solid #bbbbbb;`};
            border-bottom: ${(props) =>
              props.selectedLevel === "3"
                ? `0.45rem solid #bbbbbb`
                : `0.45rem solid #transparent;`};
            border-left: 0.45rem solid transparent;
            border-right: 0.45rem solid transparent;
          }
        }

        input {
          width: 80%;
          height: 100%;
          background-color: #f4f4f4;
          border: 1px solid #dddddd;
          border-radius: 0.4rem;
          font-size: 1.6rem;
          padding-left: 1rem;
        }
      }
    }

    .form-submit {
      width: 17.6rem;
      height: 4.6rem;
      line-height: 4.6rem;
      text-align: center;
      font-size: 1.6rem;
      background-color: #1677ff;
      border-radius: 0.4rem;
      color: white;
      cursor: pointer;
      transition: all 100ms ease-in-out;

      &:hover {
        background-color: white;
        border: 1px solid #1677ff;
        color: #1677ff;
      }
    }
  }
`;

class SignUpForm extends Component {
  state = {
    selectedLevel0: {
      name: "请选择培训大类",
    },
    selectedLevel1: {
      name: "请选择科目",
      id: "",
      level: "",
      is_sw: "",
    },
    selectedLevel2: {
      name: "请选择二级分类",
      id: "",
      level: "",
      is_sw: "",
    },
    selectedLevel3: {
      name: "请选择三级分类",
      id: "",
      level: "",
      is_sw: "",
    },
    selectedLevel: "",
    level1Subs: [],
    level2Subs: [],
    level3Subs: [],
    haveLevel2: false,
    haveLevel3: false,
    studentName: "",
    idNumber: "",
    phoneNumber: "",
  };

  async componentDidMount() {
    //如果是通过点击科目进来
    if (this.props.match.params.id) {
      //获取点击科目的相关数据
      const { data } = await axios.get(
        baseUrl + parentChildrenUrl + `?id=${this.props.match.params.id}`
      );

      //设置当前大类为点击科目对应的大类
      const selectedLevel0 = {};
      switch (Number(data.is_sw)) {
        case 1:
          selectedLevel0.name = "特种作业人员";
          break;
        case 2:
          selectedLevel0.name = "特种设备人员";
          break;
        case 3:
          selectedLevel0.name = "一般工贸人员";
          break;
        case 4:
          selectedLevel0.name = "交通运输人员";
          break;
        case 5:
          selectedLevel0.name = "职业卫生人员";
          break;
        case 6:
          selectedLevel0.name = "渔业船员人员";
          break;
        case 7:
          selectedLevel0.name = "安全管理人员";
          break;
        default:
          break;
      }

      //设置一级列表数据
      let level1Subs = [];
      for (let sub of this.props.allSubs) {
        if (sub.title === selectedLevel0.name) {
          level1Subs = sub.subjects;
          break;
        }
      }

      //设置一级选中数据
      const selectedLevel1 = {};
      selectedLevel1.name = data.title;
      selectedLevel1.is_sw = data.is_sw;
      selectedLevel1.id = data.id;
      selectedLevel1.level = data.level;

      //如果没有子级则不显示下级，否则设置二级列表数据
      let haveLevel2 = true;
      let level2Subs = [];
      if (data.children.length == 0) {
        haveLevel2 = false;
      } else {
        level2Subs = data.children;
      }

      this.setState({
        selectedLevel0,
        level1Subs,
        selectedLevel1,
        haveLevel2,
        level2Subs,
      });
    }
  }

  //点击大类列表项时触发
  handleLevel0ItemClick = (sub) => {
    //设置当前数据为所选数据
    const selectedLevel0 = {};
    selectedLevel0.name = sub.title;

    //重置下级
    const selectedLevel1 = {};
    selectedLevel1.name = "请选择科目";
    selectedLevel1.id = "";
    selectedLevel1.level = "";
    selectedLevel1.is_sw = "";
    const selectedLevel2 = {};
    selectedLevel2.name = "请选择二级分类";
    selectedLevel2.id = "";
    selectedLevel2.level = "";
    selectedLevel2.is_sw = "";
    const selectedLevel3 = {};
    selectedLevel3.name = "请选择三级分类";
    selectedLevel3.id = "";
    selectedLevel3.level = "";
    selectedLevel3.is_sw = "";

    this.setState({
      selectedLevel0,
      level1Subs: sub.subjects,
      selectedLevel1,
      selectedLevel2,
      selectedLevel3,
    });
  };

  //点击一级列表项时触发
  handleLevel1ItemClick = async (sub) => {
    //获取下级数据
    const { data } = await axios.get(
      baseUrl + parentChildrenUrl + `?id=${sub.id}`
    );

    //如果没有子级则不显示下级
    let haveLevel2 = true;
    if (data.children.length == 0) {
      haveLevel2 = false;
    }

    //设置当前数据为所选数据
    const selectedLevel1 = {};
    selectedLevel1.name = sub.subName;
    selectedLevel1.id = sub.id;
    selectedLevel1.level = sub.level;
    selectedLevel1.is_sw = sub.is_sw;

    //重置下级数据
    const selectedLevel2 = {};
    selectedLevel2.name = "请选择二级分类";
    selectedLevel2.id = "";
    selectedLevel2.level = "";
    selectedLevel2.is_sw = "";
    const selectedLevel3 = {};
    selectedLevel3.name = "请选择三级分类";
    selectedLevel3.id = "";
    selectedLevel3.level = "";
    selectedLevel3.is_sw = "";

    this.setState({
      selectedLevel1,
      level2Subs: data.children,
      selectedLevel2,
      selectedLevel3,
      haveLevel2,
    });
  };

  //点击二级列表项时触发
  handleLevel2ItemClick = async (sub) => {
    //获取下级数据
    const { data } = await axios.get(
      baseUrl + parentChildrenUrl + `?id=${sub.id}`
    );

    //如果还有子级就展示第三级并设置数据
    let haveLevel3 = false;
    if (data.children.length != 0) {
      haveLevel3 = true;
    }

    //设置当前数据为所选数据
    const selectedLevel2 = {};
    selectedLevel2.name = sub.title;
    selectedLevel2.id = sub.id;
    selectedLevel2.level = sub.level;
    selectedLevel2.is_sw = sub.is_sw;

    //重置下级数据
    const selectedLevel3 = {};
    selectedLevel3.name = "请选择三级分类";
    selectedLevel3.id = "";
    selectedLevel3.level = "";
    selectedLevel3.is_sw = "";

    this.setState({
      selectedLevel2,
      selectedLevel3,
      level3Subs: data.children,
      haveLevel3,
    });
  };

  //点击三级列表项时触发
  handleLevel3ItemClick = async (sub) => {
    //设置当前数据为所选数据
    const selectedLevel3 = {};
    selectedLevel3.name = sub.title;
    selectedLevel3.id = sub.id;
    selectedLevel3.level = sub.level;
    selectedLevel3.is_sw = sub.is_sw;

    this.setState({ selectedLevel3 });
  };

  //点击大类选择框时触发
  handleLevel0Click = () => {
    if (this.state.selectedLevel === "0") {
      this.setState({ selectedLevel: "" });
    } else {
      this.setState({ selectedLevel: "0" });
    }
  };

  //点击一级选择框时触发
  handleLevel1Click = () => {
    if (this.state.selectedLevel === "1") {
      this.setState({ selectedLevel: "" });
    } else {
      this.setState({ selectedLevel: "1" });
    }
  };

  //点击二级选择框时触发
  handleLevel2Click = () => {
    if (this.state.selectedLevel === "2") {
      this.setState({ selectedLevel: "" });
    } else {
      this.setState({ selectedLevel: "2" });
    }
  };

  //点击三级选择框时触发
  handleLevel3Click = () => {
    if (this.state.selectedLevel === "3") {
      this.setState({ selectedLevel: "" });
    } else {
      this.setState({ selectedLevel: "3" });
    }
  };

  handleStudentNameChange = (e) => {
    this.setState({ studentName: e.target.value });
  };

  handleIdNumberChange = (e) => {
    this.setState({ idNumber: e.target.value });
  };

  handlePhoneNumberChange = (e) => {
    this.setState({ phoneNumber: e.target.value });
  };

  //点击提交按钮时触发
  handleFormSubmit = async () => {
    const {
      studentName,
      idNumber,
      phoneNumber,
      selectedLevel0,
      selectedLevel1,
      selectedLevel2,
      selectedLevel3,
      haveLevel2,
      haveLevel3,
    } = this.state;

    //检查各个输入项
    if (!studentName) {
      alert("请输入姓名！");
      return;
    }
    if (!idNumber) {
      alert("请输入身份证号！");
      return;
    }
    if (!phoneNumber) {
      alert("请输入手机号！");
      return;
    }
    if (
      selectedLevel0.name === "请选择培训大类" ||
      !selectedLevel1.id ||
      (haveLevel2 ? !selectedLevel2.id : false) ||
      (haveLevel3 ? !selectedLevel3.id : false)
    ) {
      alert("请选择科目！");
      return;
    }

    //处理表单数据(到此已确保表单数据没问题)
    const formData = {};
    formData.id_number = idNumber;
    formData.is_sw = selectedLevel1.is_sw;
    formData.name = studentName;
    formData.phone = phoneNumber;
    formData.registration_time = moment().format("YYYY-MM-DD HH:mm:ss");
    formData.equipment = "";
    if (selectedLevel2.id) {
      if (selectedLevel3.id) {
        formData.level2 = null;
        formData.level3 = selectedLevel3.id;
      } else {
        formData.level2 = null;
        formData.level3 = selectedLevel2.id;
      }
    } else {
      formData.level2 = null;
      formData.level3 = selectedLevel1.id;
    }

    //提交表单数据进行报名，并根据返回参数status进行提示
    const { data } = await axios.post(baseUrl + signins, formData);
    const { status } = JSON.parse(data);
    if (status == 1) {
      alert("报名成功！");
    } else if (status == 2) {
      alert("报名失败！");
    } else if (status == 3) {
      alert("已报名当前科目，请等待审核通过！");
    } else if (status == 4) {
      alert("当前科目已报名并审核通过！");
    }
  };

  render() {
    const {
      selectedLevel0,
      selectedLevel1,
      selectedLevel2,
      selectedLevel3,
      level1Subs,
      level2Subs,
      level3Subs,
      haveLevel2,
      haveLevel3,
      selectedLevel,
    } = this.state;
    const { allSubs } = this.props;

    return (
      <Div selectedLevel={selectedLevel}>
        <div className="form-main">
          <div className="form-title">学习报名</div>
          <div className="form-content">
            <div className="form-item">
              <div className="form-name level0">培训大类：</div>
              <div
                className="form-radio level0"
                onClick={this.handleLevel0Click}
              >
                {selectedLevel0.name}
                {selectedLevel === "0" ? (
                  <div className="radio-items-container">
                    {allSubs.map((sub, index) => (
                      <div
                        key={`radioItem-${index}`}
                        className="radio-item"
                        onClick={() => {
                          this.handleLevel0ItemClick(sub);
                        }}
                      >
                        {sub.title}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="form-item">
              <div className="form-name level1">报名科目：</div>
              <div
                className="form-radio level1"
                onClick={this.handleLevel1Click}
              >
                {selectedLevel1.name}
                {selectedLevel === "1" ? (
                  <div className="radio-items-container">
                    {level1Subs.map((sub, index) => (
                      <div
                        key={`radioItem-${index}`}
                        className="radio-item"
                        onClick={() => {
                          this.handleLevel1ItemClick(sub);
                        }}
                      >
                        {sub.subName}
                      </div>
                    ))}
                  </div>
                ) : null}
              </div>
            </div>
            {haveLevel2 ? (
              <div className="form-item">
                <div className="form-name level2"></div>
                <div
                  className="form-radio level2"
                  onClick={this.handleLevel2Click}
                >
                  {selectedLevel2.name}
                  {selectedLevel === "2" ? (
                    <div className="radio-items-container">
                      {level2Subs.map((sub, index) => (
                        <div
                          key={`radioItem-${index}`}
                          className="radio-item"
                          onClick={() => {
                            this.handleLevel2ItemClick(sub);
                          }}
                        >
                          {sub.title}
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
            {haveLevel3 ? (
              <div className="form-item">
                <div className="form-name level3"></div>
                <div
                  className="form-radio level3"
                  onClick={this.handleLevel3Click}
                >
                  {selectedLevel3.name}
                  {selectedLevel === "3" ? (
                    <div className="radio-items-container">
                      {level3Subs.map((sub, index) => (
                        <div
                          key={`radioItem-${index}`}
                          className="radio-item"
                          onClick={() => {
                            this.handleLevel3ItemClick(sub);
                          }}
                        >
                          {sub.title}
                        </div>
                      ))}
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
            <div className="form-item">
              <div className="form-name student-name">学员姓名：</div>
              <input
                onChange={this.handleStudentNameChange}
                type="text"
                placeholder="请输入本人姓名"
              />
            </div>
            <div className="form-item">
              <div className="form-name student-name">身份证号：</div>
              <input
                onChange={this.handleIdNumberChange}
                type="text"
                placeholder="请输入身份证号"
              />
            </div>
            <div className="form-item">
              <div className="form-name student-name">手机号：</div>
              <input
                onChange={this.handlePhoneNumberChange}
                type="text"
                placeholder="请输入手机号"
              />
            </div>
          </div>
          <div onClick={this.handleFormSubmit} className="form-submit">
            提交
          </div>
        </div>
        <div className="form-shadow1"></div>
        <div className="form-shadow2"></div>
      </Div>
    );
  }
}

export default SignUpForm;
